export const isValid = (cns) => {
    //// Código adaptado de https://geradornv.com.br/validar-cns/

    if (typeof cns !== 'string' || cns.length !== 15) return false;

    const calcSum = (block) => block.split("").reduce((total, value, index) => total + (value * (15 - index)), 0);

    if (["1", "2"].includes(cns[0])) {
        const pis = cns.slice(0, 11);
        const sum = calcSum(pis);
        const rest = sum % 11;
        const digit = rest === 0 ? 0 : 11 - rest;
        const result = digit === 10 ? `${pis}001${(11 - ((sum + 2) % 11))}` : `${pis}000${digit}`;
        if (result === cns) return true;
    }

    if (["7", "8", "9"].includes(cns[0])) {
        const sum = calcSum(cns);
        const result = sum % 11 === 0;
        if (result) return true;
    }

    // Se não for um CNS válido de acordo com as regras acima
    return false;
};
